"use client";
import React from "react";
import dynamic from "next/dynamic";
import type { MapProps } from "modules/common/components/map/Map";
import MapSkeleton from "modules/common/components/skeletons/map/MapSkeleton";
import { MapErrorBoundary } from "modules/common/components/map/MapErrorBoundary";

type Position = "top-left" | "top-right" | "bottom-left" | "bottom-right";

interface MapWithStoreListProps extends MapProps {
  enableStoreList?: boolean;
  storeListPosition?: Position;
  storeListCityName?: string;
  isAuthenticated?: boolean;
  storeListLayout?: "overlay" | "directory";
}

// Create dynamic component once at module level — never inside a component body
const MapWithStoreListLazy = dynamic(
  () => import("modules/common/components/map/MapWithStoreList"),
  {
    loading: () => <MapSkeleton />,
    ssr: false,
  }
);

const DynamicMapWithStoreList = (props: MapWithStoreListProps) => {
  return (
    <MapErrorBoundary className={props.className}>
      <MapWithStoreListLazy {...props} />
    </MapErrorBoundary>
  );
};

export default DynamicMapWithStoreList;
